import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { RelatorioPersonalizadoService } from 'src/app/services/relatorio/relatorio-personalizado.service';
import { HistoricoRelatorio } from 'src/models/interfaces/relatorio/historico-relatorio.interface';
import { TipoRelatorio } from 'src/models/interfaces/relatorio/tipo.relatorio.interface';
import { HomeComponent } from '../../home/home.component';
import { menuOptions } from 'src/data/menu-options.data';
import { MatSort } from '@angular/material/sort';
import { environment } from 'src/environments/environment';
import { ID_RELATORIO_ARQUIVO_RETORNO_PADRAO, NOME_HISTORICO_ARQUIVO_RETORNO, PARAMETRO_LAYOUT } from 'src/utils/reports';

@Component({
  selector: 'spe-historico-relatorios',
  templateUrl: './historico-relatorios.component.html',
  styleUrls: ['./historico-relatorios.component.scss'],
  standalone: false
})
export class HistoricoRelatoriosComponent implements OnInit {
  public apiStatus: string | null = null;
  public message: string = '';
  private menu: String = '';
  public id?: number;
  public idType?: number;
  public report?: TipoRelatorio;
  public reportName?: string = '';
  private subscriptions: Subscription[] = [];
  public readonly dataSource = new MatTableDataSource<HistoricoRelatorio>();
  public displayedColumns: string[] = ['dataInicioExecucao', 'dataFimExecucao', 'status', 'download'];
  private backUrl: string = '';
  private layout?: string;
  private onDestroy = false;
  private needRefresh = false;
  public isCaixa = localStorage.getItem('sigla') == 'CAIXA';
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    public readonly routerService: Router,
    private messageService: MessageService,
    public readonly relatorioPersonalizadoService: RelatorioPersonalizadoService,
    private route: ActivatedRoute,
    private homeComponent: HomeComponent,
    private cdr: ChangeDetectorRef
  ) {}

  private refreshView(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.setHomeVariables();
    this.subscribeMessageService();
    this.subscribeQueryParam();
    this.getRelatorioByType();
    this.getHistory();
  }

  setHomeVariables() {
    this.menu = this.routerService.url.split('/')[3];
    this.id = Number(this.routerService.url.split('/')[5].split('?')[0]);

    this.homeComponent.setNewVariables(
      'Histórico de Solicitação dos Relatórios',
      'Últimos relatórios solicitados.',
      `relatorios/${this.menu}`
    );
    switch (this.menu) {
      case 'funcionarios':
      case 'beneficios':
      case 'pedidos':
      case 'apoio':
        this.homeComponent.idleMenuContent = menuOptions[1].content;

        break;
      case 'importacao':
      case 'relatorios':
        this.homeComponent.idleMenuContent = menuOptions[3].content;
        break;
    }
  }

  subscribeMessageService() {
    const messageSubscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
      this.refreshView();
    });
    this.subscriptions.push(messageSubscription);
  }

  getRelatorioByType() {
    const subscription = this.relatorioPersonalizadoService.getRelatoriosPorTipo(this.idType!).subscribe({
      next: (data) => {
        this.report = data.find((value) => value.id === this.id);
        console.log(this.report);
        this.reportName = this.getReportName(this.report);

        this.refreshView();
      },
      error: () => {
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  }

  getReportName(report: any) {
    if (report?.id === ID_RELATORIO_ARQUIVO_RETORNO_PADRAO) {
      return NOME_HISTORICO_ARQUIVO_RETORNO;
    }
    if (this.isCaixa) {
      switch (report?.id) {
        case environment.idRelatorioMultiTransacoes:
          return 'Relatório de Transações do Cartão Despesa';
        case environment.idRelatorioBalanceMulti:
          return `Relatório de Saldo de Cartões ${this.isCaixa ? 'Despesa' : 'Multi'}`;
        case environment.idRelatorioExportarPrestacaoContas:
          return 'Exportar Prestação de Contas';
        case environment.idRelatorioExportarAdiantamentos:
          return 'Exportar Adiantamentos';
        default:
          return report?.nome;
      }
    } else {
      return report?.nome;
    }
  }

  subscribeQueryParam() {
    const queryParamsSubscription = this.route.queryParams.subscribe((params) => {
      this.idType = params.tipo;
      if (params.requestedMessage) {
        this.showMessage(params.requestedMessage);
      }
      this.backUrl = params.backUrl;
      this.layout = params[PARAMETRO_LAYOUT];
    });
    this.subscriptions.push(queryParamsSubscription);
  }

  private getHistory = () => {
    const subscription0 = this.relatorioPersonalizadoService.getSolicitacoesRelatorioByCliente(this.id!).subscribe({
      next: (data) => {
        this.dataSource.data = data;
        let report = this.dataSource.data.find((value) => {
          return value.status == 'Andamento';
        });
        if (report) {
          this.needRefresh = true;
        } else {
          this.needRefresh = false;
        }
        this.refreshView();
        setTimeout(() => {
          if (!this.onDestroy && this.needRefresh) this.getHistory();
        }, 60000);
      },
      error: () => {
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription0);
  };

  ngOnDestroy(): void {
    this.onDestroy = true;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public clickHere = (element: HistoricoRelatorio) => {
    const subscription = this.relatorioPersonalizadoService
      .baixarRelatorio(
        {
          idSolicitacaoIntegracao: element.idRelatorioIntegracao
        },
        element.nomeArquivo
      )
      .subscribe();
    this.subscriptions.push(subscription);
  };

  // public readonly getStatusColor = (status: string) => {
  //   if (status == 'Erro') {
  //     return 'red';
  //   } else if (status == 'Finalizado') {
  //     return 'green';
  //   } else {
  //     return 'blue';
  //   }
  // };

  public readonly getStatusColorClass = (status: string) => {
    if (status == 'Erro') {
      return 'error-chip';
    } else if (status == 'Finalizado') {
      return 'success-chip';
    } else {
      return 'processed-chip';
    }
  };

  public readonly getStatus = (element: HistoricoRelatorio) => {
    if (element.status == 'Erro') {
      return `Erro - ${element.observacao}`;
    } else {
      return element.status;
    }
  };

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  public returnButton = () => {
    this.backUrl
      ? this.routerService.navigate([this.backUrl])
      : this.routerService.navigate([`home/relatorios/${this.menu}/${this.id}`], {
          queryParams: this.layout ? { [PARAMETRO_LAYOUT]: this.layout } : {}
        });
  };
}
